module.exports = __webpack_public_path__ + "5ddfcddeae27e391315ab60dbb336a97.pdf";